module.exports = __webpack_public_path__ + "static/media/04-03.6fbc133d.png";